import React from 'react';
import { motion } from 'framer-motion';
import PremiumCard from '../ui/PremiumCard';
import ConstellationView from '../features/ConstellationView';

const ConstellationTab = ({ userData, currentAvatar }) => {
  return (
    <PremiumCard className="p-12 relative overflow-hidden min-h-[800px]" glow>
      {/* Ultra Enhanced Constellation Background */}
      <motion.div 
        className="absolute inset-0 pointer-events-none"
        animate={{ rotate: 0 }}
        transition={{ duration: 2 }}
      >
        <div className="absolute inset-0" style={{
          background: `
            radial-gradient(circle at 50% 50%, rgba(21,255,117,0.15) 0%, transparent 50%),
            radial-gradient(circle at 20% 80%, rgba(44,249,142,0.1) 0%, transparent 40%),
            radial-gradient(circle at 80% 20%, rgba(0,212,255,0.08) 0%, transparent 40%)
          `,
          filter: 'blur(60px)'
        }} />
      </motion.div>
      <div className="text-center mb-12 relative z-10">
        <motion.h2 
          className="text-5xl font-bold bg-gradient-to-br from-[#E8FDF2] to-[#15FF75] bg-clip-text text-transparent mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Role Constellation
        </motion.h2>
        <motion.p 
          className="text-xl text-[#8AA5A2]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Your cosmic authority visualized in the stars
        </motion.p>
      </div>
      
      {/* Use the ConstellationView component */}
      <ConstellationView userData={userData} currentAvatar={currentAvatar} />
    </PremiumCard>
  );
};

export default ConstellationTab;